module.exports = __webpack_public_path__ + "img/existing-resources-2-2.5ad6badf.jpg";